import React from 'react'
import Header from '../components/Header';
import Login from '../components/Login';

const Registration = () => {
    return (
        <div>
            <Header/>
            <Login/>
        </div>
    );
};

export default Registration